/**
 * Constant-time string comparison to prevent timing attacks.
 * Browser-compatible alternative to Node's crypto.timingSafeEqual.
 */
export const constantTimeEqual = (a: string, b: string): boolean => {
  if (a.length !== b.length) return false;
  let result = 0;
  for (let i = 0; i < a.length; i++) {
    result |= a.charCodeAt(i) ^ b.charCodeAt(i);
  }
  return result === 0;
};
